var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact"},[_c('br'),_c('h2',{attrs:{"align":"center"}},[_vm._v("Contact us")]),_c('br'),_c('contact-form'),_c('br'),_c('br')],1)}
var staticRenderFns = []

export { render, staticRenderFns }